import { configureStore } from "@reduxjs/toolkit";
import createroomreducer from "./VoiceToTextSlice"
import transcriber from "./TranscriptionSlice";


const Store = configureStore({
    reducer:{
        createRoom:createroomreducer,
        transcriptionData:transcriber,
        
     
    }
})

export default Store;